<script lang="ts">
  import { cn } from "$lib/utils";
  export let key: string;
  export let className = "";
</script>

<div class={cn("flex size-6 items-center justify-center gap-1 bg-yellow-400 text-black", className)}>
  <span class="text-xs">{key}</span>
</div>
